<template>
    <div class="dowloadurl">
        <van-cell-group title="下载链接">
            <van-cell :title="item.title" :value="item.title" :is-link="true" :url="item.url" v-for="item in urls" :key="item.url" />
        </van-cell-group>
    </div>
</template>
<script> 
import {getDownloadUrl} from "@/apis/index";
export default {
    data() {
        return {
            urls: []
        }
    },
    created() {
        getDownloadUrl().then(res => {
            this.urls = res;
        });
    }
}
</script>
<style scoped>
.dowloadurl{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(2);
    width: 35%;
    height: 35%;
    border: 1px dashed #999999;
}
</style>